import { render } from "./EventList.vue?vue&type=template&id=4bb1008c&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=4bb1008c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bb1008c"

export default script